import { Checkbox, Radio } from '@material-ui/core';
import React from 'react';
import styles from './StepSelector.module.scss';
import classNames from 'classnames';

export const StepSelector: React.FC<{
    info: string;
    text: string;
    value: boolean;
    active?: boolean;
    testId: string;
    useCheckbox?: boolean;
    error?: string;
    onClick(selected: boolean): void;
}> = props => {
    const containerClasses = classNames(styles.container, {
        [styles.active]: props.active,
        [styles.error]: !!props.error && props.active
    });

    return (
        <>
            <div
                className={containerClasses}
                onClick={() => {
                    props.onClick(!props.value);
                }}
            >
                <div className={styles.icon}>
                    {props.useCheckbox ? (
                        <Checkbox checked={props.active} data-test-id={props.testId} className={styles.checkbox} />
                    ) : (
                        <Radio checked={props.active} value={props.value} data-test-id={props.testId} />
                    )}
                </div>
                <div className={styles.information}>
                    <div className={styles.title}>{props.text}</div>
                    <div className={styles.info}>{props.info}</div>
                </div>
            </div>
            {props.error && <div className={styles.errorMessage}>{props.error}</div>}
        </>
    );
};
